import { render } from "./FormLabel.vue?vue&type=template&id=efe772a0&scoped=true"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import "./FormLabel.vue?vue&type=style&index=0&id=efe772a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe772a0"]])

export default __exports__